export class GetApplicationsForLinkingRequest{
    inspectionId: string;
    clientId: string;
    departmentId?: string;
    searchText: string;
    pageSize: number;
    pageNumber: number;
    sortField: string;
    sortDescending: boolean;

    constructor(options?: Partial<GetApplicationsForLinkingRequest>) {
        Object.assign(this, options);
    }
}

export class GetApplicationsForLinkingResponse {
    recordCount: number;
    pageCount: number;
    items: ApplicationForLinkingVM[];
}

export class ApplicationForLinkingVM {
    workflowApplicationId: string;
    startedOnUtc: Date;
    applicationNumber: string;
    applicantName: string;
    siteAddress: string;
    applicantPhoneNumber: string;
    applicantEmail: string;
    applicationType: string;
}
export class RelatedApplicationVM {
    workflowApplicationId:string
    applicationNumber:string
}

export class LinkWorkflowApplicationRequest {
    workflowApplicationId: string;
    workflowApplicationIdToLink: string;

    constructor(options?: Partial<LinkWorkflowApplicationRequest>) {
        Object.assign(this, options);
    }
}

export class UnlinkWorkflowApplicationRequest {
    workflowApplicationId: string;
    workflowApplicationIdToUnlink: string;

    constructor(options?: Partial<UnlinkWorkflowApplicationRequest>) {
        Object.assign(this, options);
    }
}
